/** Steady-state ceiling for player WebSocket reconnect delay (ms). */
export const WEBSOCKET_RECONNECT_MAX_BACKOFF_MS = 30_000

/**
 * Exponential reconnect delay for Bottleneck `failed` retries.
 * Formula: `500 + jitter(0–500) + 2^retryCount * 100`, clamped to
 * {@link WEBSOCKET_RECONNECT_MAX_BACKOFF_MS} (never reset below the computed delay).
 */
export function computeWebSocketReconnectBackoffMs(
  retryCount: number,
  random: () => number = Math.random
): number {
  const expBackoffDelayMs = 500 + random() * 500 + 2 ** retryCount * 100
  return Math.min(expBackoffDelayMs, WEBSOCKET_RECONNECT_MAX_BACKOFF_MS)
}
